<template>
  <el-card class="relative">
    <el-row>
      <div class="mb-10px">
        <el-page-header
          v-if="$route.path == '/violation/violation-record-info'"
          @back="$router.go(-1)"
          :content="$t('基本信息')"
        ></el-page-header>
        <span v-else class="border-l-3 border-color-primary flex-1 pl-10px text-18px"
          >基本信息</span
        >
      </div>
      <el-form :model="formData" ref="formRef" disabled label-width="150px">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="`${$t('姓名')}`" prop="Category">
              <el-input
                style="width: 100%;"
                size="small"
                :placeholder="`${$t('请输入')}`"
                v-model="originData.personnelName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="`${originData.totalScore === null ? $t('所属单位') : $t('部门')}`"
              prop="Category"
            >
              <el-input
                style="width: 100%;"
                size="small"
                :placeholder="`${$t('请输入')}`"
                v-model="originData.unitName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="`${$t('总积分')}`" prop="Category">
              <el-input
                style="width: 100%;"
                size="small"
                :placeholder="`${originData.totalScore === null ? '' : $t('请输入')}`"
                v-model="originData.totalScore"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="handClick">
      <el-tab-pane label="违章/处罚信息" name="first">
        <div class="flex">
          <div class="mr-10px">处罚次数：{{ originData.punishCount }}</div>
          <div class="mr-10px">违章扣分：{{ originData.penaltyScore }}</div>
          <div class="mr-10px">处罚金额(元)：{{ originData.penaltyAmount }}</div>
          <div class="mr-10px">教育培训(h)：{{ originData.trainHour }}</div>
        </div>
        <el-table
          stripe
          :data="tableListOne"
          :highlight-current-row="true"
          :row-key="(record) => record.Id"
          class="mt-20px"
        >
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column :label="`${$t('违章描述')}`" prop="description" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章类型')}`" prop="typeName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章级别')}`" prop="levelName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章时间')}`" prop="violationTime" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.violationTime | showText('time') }}
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('处罚情况')}`" prop="TradeName" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row | showText('des', 1) }}
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('操作')}`" width="200" fixed="right">
            <template #default="{ row }">
              <el-button size="mini" @click="toDetail(row)">{{ $t('查看') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="反违章/奖励信息" name="second">
        <div class="flex">
          <div class="mr-10px">奖励次数：{{ originData.rewardCount }}</div>
          <div class="mr-10px">奖励积分：{{ originData.rewardScore }}</div>
          <div class="mr-10px">奖励金额(元)：{{ originData.rewardAmount }}</div>
        </div>
        <el-table
          stripe
          :data="tableListOne"
          :highlight-current-row="true"
          :row-key="(record) => record.Id"
          class="mt-20px"
        >
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column :label="`${$t('违章描述')}`" prop="description" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章类型')}`" prop="typeName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章级别')}`" prop="levelName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章时间')}`" prop="violationTime" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.violationTime | showText('time') }}
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('奖励情况')}`" prop="TradeName" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row | showText('des', 2) }}
            </template></el-table-column
          >
          <el-table-column :label="`${$t('操作')}`" width="200" fixed="right">
            <template #default="{ row }">
              <el-button size="mini" @click="toDetail(row)">{{ $t('查看') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { ViolationRecordApi } from '@wiz-api/personnel-safety-management'
import dayjs from 'dayjs'

const violationRecordApi = new ViolationRecordApi()

export default {
  name: 'violation-file-info',
  components: {},
  computed: {
    // 兼容除saas其他项目使用该模块
    routerBase() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  props: ['userId', 'unitId'],
  filters: {
    showText: (val, type, tab) => {
      let result = ''
      if (type === 'time' && val) {
        result = dayjs(val).format('YYYY-MM-DD HH:mm:ss')
      }
      if (type === 'des') {
        result = `${tab === 1 ? '违章扣分' : '奖励积分'}${val.score}分,${
          tab === 1 ? '违章' : '奖励'
        }金额${val.amount}元`
      }
      return result
    },
  },
  data() {
    return {
      tableListOne: [],
      tableListTwo: [],
      activeName: 'first',
      formData: {},
      originData: {},
    }
  },
  created() {
    this.handClick()
    this.originData = JSON.parse(sessionStorage.getItem('CURRENT_VIOLATION_PEOPLE') || '{}')
  },
  methods: {
    async handClick() {
      let params = {}
      if (this.$route.path === `${this.routerBase}/contractor-management/person-files`) {
        params = {
          userId: this.userId,
          unitId: this.unitId,
          detialsType: this.activeName === 'first' ? 1 : 2,
        }
      } else {
        params = {
          userId: this.$route.query.userId || this.userId,
          unitId: this.$route.query.unitId || this.unitId,
          detialsType: this.activeName === 'first' ? 1 : 2,
        }
      }
      const [err, res] = await violationRecordApi.violationArchivesDetials(params)
      if (err) return
      this.tableListOne = res
    },
    toDetail(planRow) {
      if (this.$route.path === `${this.routerBase}/violation/violation-record-info`) {
        this.$router.push({
          path: `${this.routerBase}/violation/violation-dealProcess`,
          query: {
            operateType: 'vioExamineInfo',
            id: planRow.recordId,
            status: 6,
          },
        })
      } else {
        this.$emit('showviolationDialog', {
          operateType: 'vioExamineInfo',
          id: planRow.recordId,
          status: 6,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
